import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { CHECKBOX_BUTTON_SIZE } from 'b2b-components/core/components/Form/Checkbox/CheckboxButton';
import { AddToCompareAction } from 'b2b-apps/shop/product/components/ProductActions/AddToCompareAction';
import { ADD_TO_WISHLIST_STYLE_TYPE, AddToWishlistAction } from './AddToWishlistAction';
import { PDFAction } from './PDFAction';
import { Props } from './';
import './ProductActions.scss';

const ProductActions = ({ className, product }: Props): ReactElement => (
    <div className={classNames('ProductActions', className)}>
      <div className='ProductAction ProductAction--Hide'>
        <AddToCompareAction
          sku={product.sku}
          buttonSize={CHECKBOX_BUTTON_SIZE.default}
        />
      </div>

      <div className='ProductAction'>
        <AddToWishlistAction skus={[product.sku]} styleType={ADD_TO_WISHLIST_STYLE_TYPE.full} />
      </div>

      <div className='ProductAction'>
        <PDFAction product={product} />
      </div>
    </div>
);

export { ProductActions };
